.positiveValue .footer .footerRow {
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  grid-row-gap: var(--cxy-spacing-3);
}

@media (min-width: 1025px) {
  .positiveValue .footer .footerRow {
    align-items: start;
    grid-template-columns: 5fr 7fr;
    grid-template-rows: auto;
  }
}
.positiveValue .footer .footerCell {
  margin-block-end: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.positiveValue .footer .footerCell > div {
  flex-direction: row;
}
@media (min-width: 1025px) {
  .positiveValue .footer .footerSection[hidden] {
    display: block;
  }
}
.positiveValue .tableHeading button svg {
  height: var(--cxy-icon-size-s);
  width: var(--cxy-icon-size-s);
}
.positiveValue .hidden {
  padding: 0;
}
@container tableComponent (min-width: 800px) {
  .positiveValue .hidden {
    padding: var(--cxy-spacing-3) var(--cxy-spacing-4);
  }

  table.positiveValue {
    thead,
    tbody {
      tr {
        grid-template-columns: 28% 28% auto 28% !important;
      }
    }
  }
}

.indicator {
  margin-top: 3px;
}
